export const imageRefName = 'image';

export const imageRefProjection = `{
  _id,
 altText
}`;

export const imageRefQuery = groq`*[_id == $_id && _type == "sanity.imageAsset"][0] ${imageRefProjection}`;
